enum PopoverAlignmentEnum {
	start = 'start',
	end = 'end',
	center = 'center'
}

export default PopoverAlignmentEnum;
